__turbopack_context__.v({
  "answerContent": "BusinessGameFaq-module-scss-module__OpwojG__answerContent",
  "chevron": "BusinessGameFaq-module-scss-module__OpwojG__chevron",
  "container": "BusinessGameFaq-module-scss-module__OpwojG__container",
  "faqAnswer": "BusinessGameFaq-module-scss-module__OpwojG__faqAnswer",
  "faqItem": "BusinessGameFaq-module-scss-module__OpwojG__faqItem",
  "faqList": "BusinessGameFaq-module-scss-module__OpwojG__faqList",
  "faqQuestion": "BusinessGameFaq-module-scss-module__OpwojG__faqQuestion",
  "highlight": "BusinessGameFaq-module-scss-module__OpwojG__highlight",
  "open": "BusinessGameFaq-module-scss-module__OpwojG__open",
  "questionText": "BusinessGameFaq-module-scss-module__OpwojG__questionText",
  "section": "BusinessGameFaq-module-scss-module__OpwojG__section",
  "sectionHeader": "BusinessGameFaq-module-scss-module__OpwojG__sectionHeader",
  "sectionSubtitle": "BusinessGameFaq-module-scss-module__OpwojG__sectionSubtitle",
  "sectionTitle": "BusinessGameFaq-module-scss-module__OpwojG__sectionTitle",
  "visible": "BusinessGameFaq-module-scss-module__OpwojG__visible",
});
